module.exports = __webpack_public_path__ + "img/ic_20_file.462a98ce.svg";